import * as TYPES from './types'
import { functions } from '@/services/firebase'

export default {
  [TYPES.LOAD_BOTTLES] ({ commit }, { locale, callback = function(){} }) {
    const loadBottles = functions.httpsCallable('loadBottles')
    loadBottles({ locale }).then(response => {
      commit(TYPES.SET_BOTTLES, response.data)
      callback(null, true)
    })
  },
}
